export const DEFAULT_PRIMARY_COLOR = "#7F56D9";
export const DEFAULT_PRIMARY_HOVER = "#805cceff";
export const DEFAULT_PRIMARY_ACTIVE = "#6441b1ff";

export const customLightTheme = {
  token: {
    colorPrimary: DEFAULT_PRIMARY_COLOR,
    colorBorder: "#D0D5DD",
    colorBorderSecondary: "#EAECF0",
    colorText: "#101828",
    fontFamily: "Roboto",
    colorErrorHover: "#B42318",
    screenXXLMin: 1700,
    screenXXL: 1700,
    screenXLMax: 1699,
    // UI contract
    borderRadius: 8,
    borderRadiusSM: 8,
    borderRadiusLG: 8,
    colorBgContainer: "#ffffff",
    colorBgLayout: "#F9FAFB",
    colorFillAlter: "#F2F4F7",
    colorTextSecondary: "#344054",
    controlHeight: 36,
    controlHeightSM: 32,
    controlHeightLG: 44,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    paddingLG: 24,
    fontSizeSM: 12,
    fontSize: 14,
    fontSizeLG: 16,
    lineHeight: 1.428,
    boxShadow:
      "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
    boxShadowSecondary:
      "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
  },
  components: {
    Timeline: {
      colorPrimary: "#ED783E",
      dotBg: "#ED783E",
      itemPaddingBottom: "108px",
    },
    Button: {
      colorPrimaryHover: DEFAULT_PRIMARY_HOVER,
      colorPrimaryActive: DEFAULT_PRIMARY_ACTIVE,
      colorBorder: "#D0D5DD",
      colorText: "#344054",
      borderRadius: 8,
      controlHeightSM: 32,
      controlHeight: 36,
      controlHeightLG: 44,
      fontWeight: 600,
      paddingInline: 14,
      paddingInlineSM: 12,
      paddingInlineLG: 16,
      defaultShadow: "none",
      primaryShadow: "none",
      contentFontSize: 14,
      contentFontSizeSM: 12,
      contentFontSizeLG: 16,
      colorError: "#D92D20",
      colorErrorHover: "#B42318",
      colorErrorActive: "#D92D20",
      colorErrorBorderHover: "#FDA29B",
      colorLink: "#475467",
      colorLinkHover: "#344054",
      colorLinkActive: "#475467",
    },
    Progress: {
      defaultColor: DEFAULT_PRIMARY_COLOR,
    },
    Input: {
      colorBorder: "#D0D5DD",
      colorPrimaryHover: DEFAULT_PRIMARY_HOVER,
      colorError: "#FDA29B",
      colorErrorBorderHover: "#FDA29B",
      controlHeightSM: 32,
      controlHeight: 36,
      controlHeightLG: 44,
      paddingInline: 12,
      borderRadius: 8,
    },
    Form: {
      colorError: "#F04438",
      fontSize: 14,
      lineHeight: "20px",
      itemMarginBottom: 16,
      labelHeight: 20,
      verticalLabelPadding: "0 0 4px",
    },
    Radio: {
      buttonSolidCheckedActiveBg: "#fff",
      buttonSolidCheckedColor: "#fff",
    },
    Tag: {
      defaultBg: "#F9FAFB",
      defaultColor: "#344054",
      colorBorder: "#EAECF0",
      borderRadiusSM: 8,
      fontSizeSM: 12,
      lineHeightSM: 1.4,
      fontWeightStrong: 500,
    },
    Card: {
      borderRadiusLG: 8,
      paddingLG: 16,
      headerHeight: 52,
      headerFontSize: 16,
      headerFontSizeSM: 14,
    },
    Table: {
      borderColor: "#EAECF0",
      cellPaddingBlock: 12,
      cellPaddingInline: 16,
      headerBg: "#F9FAFB",
      headerColor: "#475467",
      headerBorderRadius: 8,
      headerSplitColor: "#EAECF0",
      headerSortHoverBg: "#F2F4F7",
      headerFilterHoverBg: "#F2F4F7",
      rowHoverBg: "#F9FAFB",
      fontSize: 13,
      headerFontSize: 12,
      cellFontSize: 13,
    },
    Pagination: {
      itemActiveBg: "#F2F4F7",
      itemActiveColor: "#101828",
      itemBg: "transparent",
      itemSize: 28,
      itemSizeSM: 24,
      borderRadius: 6,
      colorPrimary: "#101828",
      colorPrimaryHover: "#101828",
      colorText: "#475467",
      colorTextDisabled: "#98A2B3",
      controlHeight: 28,
      controlHeightSM: 24,
    },
    Select: {
      controlHeightSM: 32,
      controlHeight: 36,
      controlHeightLG: 44,
      optionHeight: 36,
      borderRadius: 8,
      optionSelectedBg: "#F2F4F7",
    },
    Segmented: {
      controlHeight: 36,
      itemSelectedBg: "#ffffff",
      itemHoverBg: "#F2F4F7",
      trackBg: "#F2F4F7",
    },
    Menu: {
      itemSelectedBg: "#1D2939",
      itemSelectedColor: "#fff",
    },
  },
};
